import { defineMessages } from 'react-intl';

export default defineMessages({
  getIn: {
    id: 'app.shopDetails.components.Pickup.PickupToggle.pickup.getIn',
    defaultMessage: 'Retiralo en',
  },
  distance: {
    id: 'app.shopDetails.components.Pickup.PickupToggle.pickup.distance',
    defaultMessage: 'Distancia',
  },
  walking: {
    id: 'app.shopDetails.components.Pickup.PickupToggle.pickup.walking',
    defaultMessage: 'Caminando',
  },
  time: {
    id: 'app.shopDetails.components.Pickup.PickupToggle.pickup.time',
    defaultMessage: '{maxMinutes} min',
  },
});
